type StorageProperty = {
  get<T>(key: string, defaultValue?: T): T | undefined;
  set<T>(key: string, value: T): void;
  remove(key: string): void;
};

const createStorageProperty = (getStorage: () => Storage): StorageProperty => ({
  get<T>(key: string, defaultValue?: T) {
    if (typeof window === "undefined") {
      return undefined;
    }

    const storedValue = getStorage().getItem(key);
    if (storedValue === null) {
      return defaultValue;
    }

    try {
      return JSON.parse(storedValue) as T;
    } catch {
      return defaultValue;
    }
  },

  set(key, value) {
    if (typeof window === "undefined") {
      return;
    }
    getStorage().setItem(key, JSON.stringify(value));
  },

  remove(key) {
    if (typeof window === "undefined") {
      return;
    }
    getStorage().removeItem(key);
  },
});

export const localStorageProperty = createStorageProperty(() => localStorage);

export const sessionStorageProperty = createStorageProperty(() => sessionStorage);
